import type { ADACData } from '@/components/content/welcomeModal/adacUpsell/model';

const data: ADACData = {
  defaultPlan: 'yearly',
  plans: [
    {
      id: 'monthly',
      originalPrice: {
        amount: 11.99,
        currency: 'EUR',
      },
      discountedPrice: {
        amount: 8.99,
        currency: 'EUR',
      },
    },
    {
      id: 'yearly',
      originalPrice: {
        amount: 129.49,
        currency: 'EUR',
      },
      discountedPrice: {
        amount: 97.09,
        currency: 'EUR',
      },
    },
  ],
};

export default data;
